import { ICity, IArea, IAreaCode } from './../models/IAreas/IAreas';
import { RootState } from './../redux/store';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_BASE_URL } from '../helpers/common';

export const areasApi = createApi({
  reducerPath: 'areasApi',
  tagTypes: ['Area', 'City'],
  refetchOnMountOrArgChange: true,
  baseQuery: fetchBaseQuery({
    baseUrl: API_BASE_URL,
    prepareHeaders: async (headers, { getState }) => {
      const token = (getState() as RootState).user.info.accessToken;
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (build) => ({
    getAreas: build.query<IArea[], any>({
      transformResponse: (response: { data: IArea[] }) => response.data,
      query: () => ({
        url: '/states/list',
        method: 'GET',
      }),
    }),
    getAreaCodes: build.query<IAreaCode[], any>({
      transformResponse: (response: { data: IAreaCode[] }) => response.data,
      query: () => ({
        url: '/agents/state-codes',
        method: 'GET',
      }),
    }),
    getCities: build.query<ICity[], any>({
      transformResponse: (response: { data: ICity[] }) => response.data,
      query: ({ area_id = '' }) => ({
        url: '/city',
        method: 'GET',
        params: {
          area_id,
        },
      }),
    }),
  }),
});
